import {
  AsyncMultiSelectField,
  AsyncSingleSelectField,
  CharField,
  SingleSelectField,
  SwitchField,
  TextAreaField,
} from "@inmagik/magik-ui"
import { getIn, useFormikContext } from "formik"
import { Col } from "react-bootstrap"
import { usePersonaCreate, usePersonaLazy, usePersoneLazy } from "../../hooks/persone"
import { Opera } from "../../types"
import useModalTrigger from "magik-react-hooks/useModalTrigger"
import PersonaModal from "../Persone/PersonaModal"
import { transformErrorForForm } from "../../utils/utils"
import { WysiwygField } from "../../components/WysiwygField"

export default function OperaForm({ col = 8 }: { col?: number }) {
  const { setFieldValue, values, errors, submitCount } = useFormikContext<Opera>()

  const fetchPersona = usePersonaLazy()
  const fetchPersone = usePersoneLazy()

  const [modalStateCreaPersona, modalActionsCreaPersona] = useModalTrigger()
  const createPersona = usePersonaCreate()


  return (
    <Col xs={col} className="d-flex flex-column align-items-stretch gap-4">
      <CharField
        label="Titolo"
        layout="horizontal"
        value={values.titolo}
        onChange={(value) => {
          setFieldValue("titolo", value)
        }}
        isValid={submitCount > 0 ? (!getIn(errors, "titolo") === true ? undefined : false) : undefined}
        errorMessage={getIn(errors, "titolo")}
        required
      />
      <WysiwygField
        label="Varianti titolo"
        layout="horizontal"
        value={values.varianti_titolo}
        onChange={(value) => {
          setFieldValue("varianti_titolo", value)
        }}
      />
      <AsyncSingleSelectField
        label="Autore"
        layout="horizontal"
        placeholder="Seleziona un autore"
        required
        onChange={(value) => {
          setFieldValue("autore", value)
        }}
        clearable
        value={values.autore}
        loadOptions={(inputValue: string) => {
          return fetchPersone({ search: inputValue }).then((persone) => {
            return persone.results.map((persona) => ({
              label: persona.nome,
              value: persona.id,
            }))
          })
        }}
        loadInitialValue={(id: number) =>
          fetchPersona(id).then((persona) => {
            return { label: persona.nome, value: persona.id }
          })
        }
        isValid={submitCount > 0 ? !getIn(errors, "autore") : undefined}
        errorMessage={getIn(errors, "autore")}
      >
        <SingleSelectField.Add
          onClick={() => {
            modalActionsCreaPersona.open("autore")
          }}
        />
      </AsyncSingleSelectField>
      <AsyncSingleSelectField
        label="Traduttore"
        layout="horizontal"
        placeholder="Seleziona un traduttore"
        onChange={(value) => {
          setFieldValue("traduttore", value)
        }}
        clearable
        value={values.traduttore}
        loadOptions={(inputValue: string) => {
          return fetchPersone({ search: inputValue }).then((persone) => {
            return persone.results.map((persona) => ({
              label: persona.nome,
              value: persona.id,
            }))
          })
        }}
        loadInitialValue={(id: number) =>
          fetchPersona(id).then((persona) => {
            return { label: persona.nome, value: persona.id }
          })
        }
        isValid={submitCount > 0 ? !getIn(errors, "traduttore") : undefined}
        errorMessage={getIn(errors, "traduttore")}
      >
        <SingleSelectField.Add
          onClick={() => {
            modalActionsCreaPersona.open("traduttore")
          }}
        />
      </AsyncSingleSelectField>
      <WysiwygField
        label="Varianti autore"
        layout="horizontal"
        value={values.varianti_autore}
        onChange={(value) => {
          setFieldValue("varianti_autore", value)
        }}
      />
      <AsyncMultiSelectField
        label="Destinatari"
        layout="horizontal"
        placeholder="Seleziona uno o più destinatari"
        onChange={(value) => {
          setFieldValue("destinatari", value)
        }}
        clearable
        value={values.destinatari || []}
        loadInitialValues={(ids: number[]) =>
          Promise.all(ids?.map((id) => fetchPersona(id).then((persona) => ({ label: persona.nome, value: persona.id })))) 
        }
        loadOptions={(inputValue: string) => {
          return fetchPersone({ search: inputValue }).then((persone) => {
            return persone.results?.map((persona) => ({
              label: persona.nome,
              value: persona.id,
            }))
          })
        }}
      >
        <AsyncMultiSelectField.Add
          onClick={() => {
            modalActionsCreaPersona.open("destinatari")
          }}
        />
      </AsyncMultiSelectField>

      <WysiwygField
        label="Bibliografia"
        layout="horizontal"
        value={values.bibliografia}
        onChange={(value) => {
          setFieldValue("bibliografia", value)
        }}
      />

      <WysiwygField
        label="Edizione moderna"
        layout="horizontal"
        value={values.edizione_moderna}
        onChange={(value) => {
          setFieldValue("edizione_moderna", value)
        }}
      />
      <WysiwygField
        label="Testimonios manuscritos"
        layout="horizontal"
        value={values.edizioni_scritte_a_mano}
        onChange={(value) => {
          setFieldValue("edizioni_scritte_a_mano", value)
        }}
      />
      <WysiwygField
        label="Testimonios de lectura"
        layout="horizontal"
        value={values.edizioni_di_letture}
        onChange={(value) => {
          setFieldValue("edizioni_di_letture", value)
        }}
      />
      <SwitchField
        label="Bozza"
        layout="horizontal"
        value={values.bozza}
        onChange={(value) => {
          setFieldValue("bozza", value)
        }}
      />
      {modalStateCreaPersona.isOpen && (
        <PersonaModal
          show={modalStateCreaPersona.isOpen}
          onClose={modalActionsCreaPersona.close}
          save={(valuesPersona, actions) => {
            return createPersona.mutateAsync(valuesPersona).then((persona) => {
              if (modalStateCreaPersona.value === "autore") {
                setFieldValue("autore", persona.id)
              } else if (modalStateCreaPersona.value === "traduttore") {
                setFieldValue("traduttore", persona.id)
              } else if (modalStateCreaPersona.value === "destinatari") {
                setFieldValue("destinatari", [...values.destinatari, persona.id])
              }
              modalActionsCreaPersona.close()
            }).catch((e) => {
              actions.setErrors(transformErrorForForm(e))
            })
          }}
          title={`Nuovo ${modalStateCreaPersona.value}`}
        />
      )}
    </Col>
  )
}
